Object.defineProperty(exports, "__esModule", {
    value: true
});
var _call_super = require("@swc/helpers/_/_call_super");
var _class_call_check = require("@swc/helpers/_/_class_call_check");
var _create_class = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var require_logger = require('../logger.cjs');
var require_tool = require('../tool.cjs');
var require_syncHook = require('./syncHook.cjs');
//#region src/utils/hooks/syncWaterfallHook.ts
function checkReturnData(originalData, returnedData) {
    if (!require_tool.isObject(returnedData)) return false;
    if (originalData !== returnedData) {
        for(var key in originalData)if (!(key in returnedData)) return false;
    }
    return true;
}
var SyncWaterfallHook = /*#__PURE__*/ function(_require_syncHook_SyncHook) {
    "use strict";
    _inherits._(SyncWaterfallHook, _require_syncHook_SyncHook);
    function SyncWaterfallHook(type) {
        _class_call_check._(this, SyncWaterfallHook);
        var _this;
        _this = _call_super._(this, SyncWaterfallHook);
        _this.onerror = require_logger.error;
        _this.type = type;
        return _this;
    }
    _create_class._(SyncWaterfallHook, [
        {
            key: "emit",
            value: function emit(data) {
                if (!require_tool.isObject(data)) require_logger.error(`The data for the "${this.type}" hook should be an object.`);
                for (var fn of this.listeners)try {
                    var tempData = fn(data);
                    if (checkReturnData(data, tempData)) data = tempData;
                    else {
                        this.onerror(`A plugin returned an unacceptable value for the "${this.type}" type.`);
                        break;
                    }
                } catch (e) {
                    require_logger.warn(e);
                    this.onerror(e);
                }
                return data;
            }
        }
    ]);
    return SyncWaterfallHook;
}(require_syncHook.SyncHook);
//#endregion
exports.SyncWaterfallHook = SyncWaterfallHook;
exports.checkReturnData = checkReturnData; //# sourceMappingURL=syncWaterfallHook.cjs.map
